import { render, staticRenderFns } from "./TableList.vue?vue&type=template&id=518a951b&scoped=true"
import script from "./TableList.vue?vue&type=script&lang=js"
export * from "./TableList.vue?vue&type=script&lang=js"
import style0 from "./TableList.vue?vue&type=style&index=0&id=518a951b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518a951b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('518a951b')) {
      api.createRecord('518a951b', component.options)
    } else {
      api.reload('518a951b', component.options)
    }
    module.hot.accept("./TableList.vue?vue&type=template&id=518a951b&scoped=true", function () {
      api.rerender('518a951b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chart/TableList.vue"
export default component.exports